import { Injectable } from '@angular/core';
import { AuthConfig } from '@michelin/auth';
export interface EnvConfiguration {
  ENVIRONMENT: string;
  FORGEROCK_ISSUER: string;
  FORGEROCK_CLIENTID: string;
  oauth2_scopes: string;
  oauth2_redirect_uri: string;
  FORGEROCK_LOGOUT_REDIRECT: string;
  BACKEND_URL: string;
  BACKEND_SUB_PATH: string;
  REDIRECT_URL: string;
  WELL_KNOWN: string;
  AUTH_BACKEND_URL: string;
  KEY_TOKEN: string;
  AUTH_TXN_API_KEY: string;
  AUTH_TXN_API_SECRET: string;
  APP_URLS: Record<string, string>;
}

interface CustomWindow extends Window {
  // add you custom properties and methods
  dynamicConf: Record<string, unknown>;
}

@Injectable({ providedIn: 'root' })
export class EnvConfigurationService {
  public static loadDynamicConf(): void {
    EnvConfigurationService.configuration = {
      ...EnvConfigurationService.configuration,
      ...(window as CustomWindow & typeof globalThis).dynamicConf
    };
  }

  // This is default configuration, these values are public and can be retreive in production.
  
  // They are overriden with config.json provided with a k8s configmap. See config.json in .k8s overlays folder
  public static configuration: EnvConfiguration = {
    ENVIRONMENT: 'local',
    FORGEROCK_ISSUER: 'https://login-indus-fed.michelin.com:443/am/oauth2',
    FORGEROCK_CLIENTID: 'DEV-EB1',
    oauth2_scopes: '',
    oauth2_redirect_uri: `${window.location.origin}`,
    FORGEROCK_LOGOUT_REDIRECT: `${window.location.origin}/?loggedout`,
    BACKEND_URL: 'http://localhost:8098',
    BACKEND_SUB_PATH: '/api/v1',
    REDIRECT_URL: 'http://localhost:4200',
    WELL_KNOWN: 'https://login-dev-fed.michelin.com/am/oauth2/.well-known/openid-configuration',
    AUTH_BACKEND_URL: 'http://localhost:8082/api',
    KEY_TOKEN: 'TOKEN_JWT',
    AUTH_TXN_API_KEY: 'pem-local-764a52be-8560-4553-9a5f-8f70c6de4d71',
    AUTH_TXN_API_SECRET: 'UHmdkvmTCO9b4EgGOVlM',
    // Base URL de cada app do portal, chaveado pelo trigram usado em AppCard.trigram.
    APP_URLS: {
      dre: 'https://app-dre.dk8snca2.aze.michelin.com',
      tld: 'https://app-tld.dk8snca2.aze.michelin.com',
      joa: 'https://app-voucher.dk8snca2.aze.michelin.com',
      bib: 'http://localhost:4300',
      pw: 'http://localhost:4300',
      rme: 'http://localhost:4300'
    }
  };
  /**
   * Provider configuration for authent lib reusable.
   *
   * @returns Configuration for authent lib
   */
  public static getAuthConfigEnv(): AuthConfig {
    return {
      authOnAppInitializer: false,
      issuer: EnvConfigurationService.configuration.FORGEROCK_ISSUER,
      redirectUri: EnvConfigurationService.configuration.oauth2_redirect_uri,
      clientId: EnvConfigurationService.configuration.FORGEROCK_CLIENTID,
      scope: EnvConfigurationService.configuration.oauth2_scopes,
      postLogoutRedirectUri: EnvConfigurationService.configuration.FORGEROCK_LOGOUT_REDIRECT,
      bearerAllowedUrls: [EnvConfigurationService.configuration.BACKEND_URL],
      sessionChecksEnabled: false
    };
  }
  public static getEnv(): string {
    return EnvConfigurationService.configuration.ENVIRONMENT;
  }
}

EnvConfigurationService.loadDynamicConf();
